import React, { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DashboardHeader } from '../../../components/common';
import RequestDrawer from '../../../components/requests/RequestDrawer';
import RequestsTable from '../../../components/requests/RequestsTable';
import { PriceChangeFreezeBanner } from '../../../components/requests/PriceChangeFreezeBanner';
import {
    RequestDrawerProvider,
    useRequestDrawer,
} from '../../../context/RequestDrawerContext';

function RequestsPageContent() {
    const [searchParams, setSearchParams] = useSearchParams();
    const {
        open,
        close,
        isOpen,
        requestId: contextRequestId,
    } = useRequestDrawer();

    const requestId = useMemo(() => {
        return searchParams.get('requestId');
    }, [searchParams]);

    useEffect(() => {
        if (requestId && !isOpen) {
            open(null, requestId);
        }
    }, [requestId, isOpen, open]);

    useEffect(() => {
        if (requestId && isOpen && requestId !== contextRequestId) {
            open(null, requestId);
        }
    }, [requestId, isOpen, contextRequestId, open]);

    const handleClose = () => {
        close();
        setSearchParams({});
    };

    return (
        <>
            <RequestDrawer onClose={handleClose} />
            <div className="relative">
                <DashboardHeader
                    friendlyLabels={[
                        {
                            originalLabel: 'price-change',
                            friendlyLabel: 'Price Change',
                        },
                    ]}
                    title="Requests"
                />
                <div className="px-11 flex flex-col gap-4">
                    <PriceChangeFreezeBanner divisionalManagerOnly />
                    <RequestsTable userId={null} />
                </div>
            </div>
        </>
    );
}

function RequestsPage() {
    return (
        <RequestDrawerProvider>
            <RequestsPageContent />
        </RequestDrawerProvider>
    );
}

export default RequestsPage;
